import microsoftLogo from '@/assets/microsoft-logo.svg';
import { authClient } from '@/lib/auth-client';
import { Button, Card, Stack, Title } from '@mantine/core';
import { IconCode, IconDatabaseCog } from '@tabler/icons-react';

export default function Login() {
  return (
    <div
      css={{
        flex: 1,
        display: 'grid',
        gridTemplateRows: '1fr max-content 1fr',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack flex={1} align="center">
        <Title>Index Manager</Title>
        <IconDatabaseCog size="10rem" />
      </Stack>

      <Card withBorder>
        <Stack>
          <Title order={2} size="1.2rem">
            Login
          </Title>

          <MicrosoftLoginButton />

          {/* dev bundle only; the endpoint only exists with NODE_ENV=development or E2E_TEST_LOGIN on the server */}
          {import.meta.env.DEV && <DevLoginButton />}
        </Stack>
      </Card>
    </div>
  );
}

function MicrosoftLoginButton() {
  function login() {
    authClient.signIn.social({
      provider: 'microsoft',
      callbackURL: location.href,
    });
  }

  return (
    <Button
      onClick={login}
      leftSection={
        <img
          src={microsoftLogo}
          alt="Microsoft Logo"
          css={{
            width: 21,
            height: 21,
          }}
        />
      }
      css={{
        color: '#FFFFFF',
        backgroundColor: '#2F2F2F',
        fontWeight: 600,
      }}
    >
      Sign in with Microsoft
    </Button>
  );
}

/** Signs in as a local admin user without Azure AD. Only rendered in the dev bundle. */
function DevLoginButton() {
  async function login() {
    const { error } = await authClient.$fetch('/test-login', { method: 'POST', body: {} });

    if (error) {
      throw new Error(`Dev login failed: ${error.status} ${error.statusText}`);
    }

    location.reload();
  }

  return (
    <Button variant="default" leftSection={<IconCode size={21} />} onClick={login}>
      Dev login (admin)
    </Button>
  );
}
